
import ConfirmModal from '../components/ConfirmModal.vue'

class CommonsUI {

  constructor(vm) {
    this.vm = vm;
  }

  // ------------------------------------------------------------------------------------------------------------
  // 프로그래스바
  // ------------------------------------------------------------------------------------------------------------
  progressStart() { this.vm.$Progress.start()  }
  progressEnd()   { this.vm.$Progress.finish() }
  progressFail()  { this.vm.$Progress.fail()   }


  // ------------------------------------------------------------------------------------------------------------
  // 입력값 체크
  // ------------------------------------------------------------------------------------------------------------
  // 입력값 체크 클리어
  inputErrorClear() {
    document.querySelectorAll(".input-error").forEach(e => e.remove())
  }

  // 입력값 체크결과 표시
  showInputError(data) {
    // if (data.type == "InputError") {

      let msg = ""
      data.errors.forEach(({field, defaultMessage})=>{

        msg += "\n - " + defaultMessage

        var obj = document.getElementById("input-sitem." + field);
        if (obj) {
          var obj2 = obj.closest('td');
          var jbBtn = document.createElement('span');
          var jbBtnText = document.createTextNode(defaultMessage);
          jbBtn.appendChild( jbBtnText );
          jbBtn.classList.add("input-error");
          obj2.appendChild( jbBtn );
      }

      });
      // alert("입력 오류가 발생했습니다\n" + msg)
      this.alert("입력 오류가 발생했습니다\n" + msg, "오류", { color: "red"})
    // }
  }

  // ------------------------------------------------------------------------------------------------------------
  // 서버오류 체크
  // ------------------------------------------------------------------------------------------------------------
  checkResponseType(ret) {

    if (ret && ret.data && ret.data.type) {
      switch(ret.data.type) {
        case "InputError": this.showInputError(ret.data); return true;
        case "ScriptException":
          this.alert(ret.data.message, "알림", { color: "blue"});
          return true;
        case "ApiError":
          if (ret.data.message) {
            this.alert_error(ret.data.message, "오류", { color: "red"});
          } else {
            this.alert("서버 오류가 발생했습니다[52]\n", "오류", { color: "red"});
          }
          return true;
      }
    }

    return false
  }

  procError(error) {

    console.log("error", error)

    if (error && error.response) {

      console.log("error.response", error.response)

      // 입력오류인 경우
      if (error.response.data && error.response.data.type == "InputError") {
        this.showInputError(error.response.data)
        return true
      }

      if (error.response.status == 400) {
        this.alert("서버 오류가 발생했습니다[5]\n" + error, "오류", { color: "red"})
        return true

        // this.showInputError(error.response.data)
        // return true
      }

      if (error.response.status == 500) {
        if (error.response.data) {
          if (error.response.data.indexOf && error.response.data.indexOf("Proxy error: Could not proxy request") == 0) {
            this.alert("서버 오류가 발생했습니다[3]\n\n" + error.response.statusText + "\n\n서버가 실행중인지 확인하세요.", "서버 오류", { color: "red"})
            return true
          }
        }
        this.alert("서버 오류가 발생했습니다[4]\n" + error.response.data.message, "서버 오류", { color: "red"})
        return true
      }
    }

    this.alert("서버 오류가 발생했습니다[7]\n" + error, "오류", { color: "red"})
  }

  // ------------------------------------------------------------------------------------------------------------
  // 토스트 컴펌 알럿
  // ------------------------------------------------------------------------------------------------------------

  // 토스트
  toast(msg, opt) {
    this.notify(msg, opt)
  }

  /*
사용법
notify("메세지", {type: 'success', title: '성공'})
notify("메세지", {type: 'warn'})
notify("메세지", {type: 'error'})
   */
  notify(msg, opt) {

    let data = {
      group: 'main',
      text: msg.replace(/\n/g, "<br/>"),
      duration: 2500,
      title: '알림',
      ...opt,
    }

    // if (opt) {
    //   if (opt.title) data.title = opt.title
    //   if (opt.type ) data.type  = opt.type
    //   if (opt.group) data.group  = opt.group
    // }

    this.vm.$notify(data)
  }

  /*
      ui.confirm('진짜 ?')
        .then(res => alert("진짜!" + res))

      (async () => {
        let res = await ui.confirm("정말 삭제 ?", "확인")
        alert("삭제1");
        if (res) {
          alert("삭제2");
        }
      })();

  */
  // async confirm(msg, title, opts) {
  //   let opt = {}
  //   if (title) opt.title = title
  //   if (opts) opt = {...opts, ...opt}
  //   let res = await this.vm.$confirm(msg, opt)
  //   // let res = confirm(msg)
  //   return res;
  // }

  // confirm 인스턴스를 설정한다.
  // modal dialog 같은곳에서 confirm 이 실행될 경우 modal 뒤에서 뜨기 때문에 필요하다. : sample2 참고
  setConfirmRef(confirmRef) {
    this.confirmRef = confirmRef
  }

  confirmInst() {
    return this.confirmRef || this.vm.$root.$confirm
  }

  // confirm(msg, title, opts) {
  //   let opt = {}
  //   if (title) opt.title = title
  //   if (opts) opt = {...opts, ...opt}
  //   console.log("opts = ", opts);

  //   return this.confirmInst()(msg, opt)
  // }
  // confirm(msg, title, opts) {
  //   let opt = {}
  //   if (title) opt.title = title
  //   if (opts) opt = {...opts, ...opt}
  //   console.log("opts = ", opts);

  //   return this.confirmInst()(msg, opt)
  // }

  confirm(message, title, opts) {

    let options = {}
    if (title) options.title = title // 제목
    if (opts) options = {...options, ...opts} // 추가 옵션
    options.message = message.replace(/\n/g,"<br/>") // 본문

    const defaultOptions = {
      title: null,
      color: 'primary',
      width: 500,
      zIndex: 200,
      alert : false,
    }

    options = {...defaultOptions, ...options}
    if (!options.title) {
      options.title = options.alert ? "알림" : "확인"
    }

    const modalName = "confirm_" + T.randomAZ(10) // 모달 이름 (unique)

    let opt = {}
    const modal = this.vm.$modal
    modal.show(ConfirmModal, {
      // 프로퍼티
      ...options,
      //  콜백
      cb_agree : () => { opt.resolve(true) ; modal.hide(modalName) }, // 확인 클릭
      cb_cancel: () => { opt.resolve(false); modal.hide(modalName) }, // 취소 클릭
    }, {
      // 모달 속성
      name: modalName,
      height: 'auto',
      // scrollable: true, // height: auto 하고 scrollable:true 는 한세트
      // scrollable: true를 하게되면 IE9 에서 작동하지 않는다. 절대 주지 말자.
      // 또는 $device.fullBrowserVersion == 9 && $device.isIE == true 일때 false 로 하고 그 외에는 true로 하자
      width: options.width,
      // draggable: true,
      draggable: ".window-header",
      resizable: true,
      adaptive: true,
      pivotY: 0.3,
      reset: true,
    }, {
      // 이벤트
      // 'before-close': (e,v) => { console.log('모달을 닫는다1. event =', e); console.log('모달을 닫는다2. event =', v);  },
      // 'closed': (e,v) => { console.log('모달3 CLOSED =', e); console.log('모달4 CLOSED =', v); },
    })

    return new Promise((resolve, reject) => {
      opt.resolve = resolve
      opt.reject = reject
    })
  }

  // alert(msg, title, opts) {
  //   let opt = { alert: true }
  //   if (title) opt.title = title
  //   if (opts) opt = {...opts, ...opt}
  //   return this.confirmInst()(msg, opt)
  // }
  alert(msg, title, opts) {
    let options = opts || {}
    return this.confirm(msg, title, {...options, alert: true })
  }

  alert_error(msg, title) {
    return this.alert(msg, title || '오류', {type: 'error'})
  }

  // ------------------------------------------------------------------------------------------------------------
  // 입력체크
  // ------------------------------------------------------------------------------------------------------------

  chkEmpty(target, msg, focusRef) {
    const vm = this.vm
    if (_.isEmpty(_.get(vm.$data, target))) {
      this.alert(msg)
        .then(()=>focusRef && vm.$refs[focusRef].focus())
      return 1
    } else {
      return 0
    }
  }


  // ------------------------------------------------------------------------------------------------------------
  // 코드설정
  // ------------------------------------------------------------------------------------------------------------

  codeLoad(codeList, cb) {
    const vm = this.vm
    vm.$store.dispatch("code/CODE_LOAD", codeList)
        .then(cb);

    // console.log(codeList)
    // localhost:8080/front/api/commonCode?codeList=A50000,A60000,A70000,A80000,B10000,B10100
    // vm.$http.get(vm.$api + '/common/commonCode', { params: {codeList}})
    //   .then(ret => {
    //     cb(ret.data)
    //   }).catch(e=>ui.procError(e))
  }

  /**
    * 일반적인 http get
    */
  httpGet(path, params, cbRet, cbErr, cbFinal) {
    const vm = this.vm
    vm.$Progress.start()
    vm.$http.get(vm.$api + path, { params : { _r : Math.random(), ...params } })
      .then(v=>{
        if (this.checkResponseType(v)) return
        cbRet && cbRet(v)
      })
      .catch(e=> {
        cbErr && cbErr(e)
        this.procError(e)
      })
      .then(()=>{
        vm.$Progress.finish()
        cbFinal && cbFinal()
      })
  }

  /**
   * 일반적인 http post
   */
  httpPost(path, params, cbRet, cbErr, cbFinal) {

    const vm = this.vm
    this.inputErrorClear()
    vm.$Progress.start()
    vm.$http.post(vm.$api + path, params)
      .then(v=>{
        if (this.checkResponseType(v)) return
        cbRet && cbRet(v)
      })
      .catch(e=> {
        cbErr && cbErr(e)
        this.procError(e)
      })
      .then(()=>{
        vm.$Progress.finish()
        cbFinal && cbFinal()
      })
  }


  /**
   * [템플릿] list 에서 목록 가져오기
   */
  httpGetList(list, path, params, cbRet, cbErr, cbFinal) {

    const vm = this.vm
    const _ = this.vm._

    list.loading = true

    this.httpGet(path, params,
      ret=>{
        if (this.checkResponseType(ret)) return
        if (cbRet) {
          cbRet(ret, list)
        } else {
          list.totalCount  = _.get(ret, "data.rs1[0].tot_rows", 0)
          list.items       = _.get(ret, "data.rs2", [])
        }
      },
      e=> {
        cbErr && cbErr(e)
        this.procError(e)
      },
      ()=> {
        cbFinal && cbFinal()
        list.loading = false
      }
    )
  }


  /**
    * [템플릿] 상세 가져오기
    */
  httpGetDetail(path, params, cbRet, cbErr, cbFinal) {

    const vm = this.vm

    this.inputErrorClear()
    vm.detail_loading = true

    this.httpGet(path, params,
      ret => {
        if (this.checkResponseType(ret)) return
        if (cbRet) {
          cbRet(ret)
        } else {
          vm.sitem = _.get(ret, "data.rs1[0]")
        }
      },
      null,
      () => {
        cbFinal && cbFinal()
        vm.detail_loading = false
      }
    )
  }


  /**
   * [템플릿] 상세 POST
   */
  httpPostDetail(path, params, cbRet, cbErr, cbFinal) {

    const vm = this.vm
    this.inputErrorClear()
    vm.detail_loading = true

    vm.$http.post(vm.$api + path, params)
      .then(v=>{
        if (this.checkResponseType(v)) return
        cbRet && cbRet(v)
      })
      .catch(e=> {
        cbErr && cbErr(e)
        this.procError(e)
      })
      .then(()=>{
        cbFinal && cbFinal()
        vm.detail_loading = false
      })
  }

}

// ------------------------------------------------------------------------------------------------------------
// 설치
// ------------------------------------------------------------------------------------------------------------

const Plugin = {
  install (Vue) {
    if (this.installed) {
      return
    }
    this.installed = true

    /*
      commons-ui 설치 방법에 대한 끝없는 고민....

      처음에는 그냥 필요한 파일마다 import
      두번재는 mixin 으로 this.$ui 사용
      결국 this 의 압박에 못이겨 그냥 ui 변수 만들어서 사용하는 것으로 결정.
      단, import 문장은 낭비로 보여서 플러그인 설치하고 create()에 연결

      let ui
      export default {
        created() {
          ui = this.$ui
        },

      또는 그냥 필요할때마다 this.$ui.alert('어쩌고') 이렇게 써도 된다.
      ( 컴포넌트에서 별도 설정 없이 vue instance에 접근 가능하면 좋을텐데... )

    */

    // Vue.prototype.$ui = function (vm) {
    //   return new CommonsUI(vm)
    // }

    Vue.mixin({
      beforeCreate () {
        this.$ui = new CommonsUI(this)
      }
    })
  }
}

export default Plugin

// export default CommonsUI


